import React from 'react'
import * as css from './ManagementOC.css'
// Const
import {NAME_REQUEST_BILLING} from '../constants/constants'

export const PanelDataVendor = ({}) => {
    return (
        <div className="panel panel-info">
            <div className="panel-heading">Datos Proveedor</div>
            <div className="panel-body">
                <ul className="list-group">
                    <li className={`list-group-item ${css.listGroupItem}`}>
                        <span className="badge">76.312.497-5</span>
                        Rut
                    </li>
                    <li className={`list-group-item ${css.listGroupItem}`}>
                        <span className="badge">SEI Ingenieria y Servicios SPA.</span>
                        Empresa
                    </li>
                    <li className={`list-group-item ${css.listGroupItem}`}>
                        <span className="badge">mgamboa@seiconsultores.cl</span>
                        Correo
                    </li>
                </ul>
            </div>
        </div>
    )
}
export const PanelDataRequest = ({}) => {
    return (
        <ul className="list-group">
            <li className={`list-group-item ${css.listGroupItem}`}>
                <span className="badge">Rodrigo Muñoz</span>
                Responsable Aprobación OC
            </li>
            <li className={`list-group-item ${css.listGroupItem}`}>
                <span className="badge">Clara Rivera Villagrán</span>
                Nombre Solicitante
            </li>
            <li className={`list-group-item ${css.listGroupItem}`}>
                <span className="badge">13.235.458-8</span>
                Rut Solicitante
            </li>
            <li className={`list-group-item ${css.listGroupItem}`}>
                <span className="badge">Control de Inventarios y Existencias</span>
                Nombre Area
            </li>
        </ul>    
    )
}
export const PanelDataDocument = ({status, creationDate, lastUpdate}) => {
    return (
        <ul className="list-group">
            <li className={`list-group-item ${css.listGroupItem}`}>
                <span className="badge">{creationDate}</span>
                Fecha solicitud
            </li>
            <li className={`list-group-item ${css.listGroupItem}`}>
                <span className="badge">Orden de compra standar</span>
                Tipo Orden de Compra
            </li>
            <li className={`list-group-item ${css.listGroupItem}`}>
                <span className="badge">{NAME_REQUEST_BILLING[status]}</span>
                Estado Actual
            </li>
            <li className={`list-group-item ${css.listGroupItem}`}>
                <span className="badge">{lastUpdate}</span>
                Ultima Actualización
            </li>
        </ul>
    )  
}


// WEBPACK FOOTER //
// ./frontEnd/billing/management-oc/Panels.jsx